module.exports = __webpack_public_path__ + "static/Report--ClickUp-2bda1693e4d2de777274096f0f993083.png";